import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Image, Table } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import SubtleBadge from 'components/common/SubtleBadge';
import SimpleBarReact from 'simplebar-react';
import moment from 'moment';
import Avatar from 'components/common/Avatar';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { updateNurseTimeOff } from 'nursd-dashboard/api/timeoffNurse';
import { toast } from 'react-toastify';
import { socket } from 'nursd-dashboard/api/socket';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getNurseAvaJobDate } from 'nursd-dashboard/api/nurseTable';
// import IconButton from 'components/common/IconButton';

export function timeDifferentCard(sTime, eTime) {
  const startTime = moment(moment(new Date(sTime)).format('hh:mma'), 'hh:mm A');

  const start = moment(new Date(sTime));
  const end = moment(new Date(eTime));

  const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
  const endTimeEnd = moment(
    moment(new Date(eTime)).format('hh:mma'),
    'hh:mm A'
  ).add(1, 'day');

  const duration = moment.duration(endTime.diff(startTime));
  const durationEnd = moment.duration(endTimeEnd.diff(startTime));

  const hours = Math.floor(duration.asHours());
  const hoursEnd = Math.floor(durationEnd.asHours());
  const minutes = Math.floor(duration.asMinutes()) - hours * 60;

  const onlyHours = `${
    end.hour() <= 12 && start.hour() <= 12
      ? hours
      : end.hour() <= 12
      ? hoursEnd
      : hours
  }${hours <= 1 ? 'h' : 'h'} ${minutes <= 0 ? '' : `${minutes}m`}`;

  return onlyHours;
}

const TransactionItem = ({
  summary: {
    approvedManagerData,
    nurseCancelNotes,
    timeOffReason,
    startDate,
    startTime,
    endDate,
    endTime,
    comments,
    status,
    nurseData,
    id
  },
  isLast,
  facility,
  refresh,
  setRefresh
}) => {
  const { authToken } = useAuth();

  const actionTimeOff = async approveStatus => {
    if (approveStatus === 'Approved') {
      const resp = await getNurseAvaJobDate(
        authToken,
        Number(nurseData?.id),
        nurseData?.uniqueId,
        moment(startDate).format('YYYY-MM-DD'),
        moment(endDate).format('YYYY-MM-DD'),
        moment(startTime).format('hh:mm a'),
        moment(endTime).format('hh:mm a')
      );

      if (resp?.availableTime) {
        try {
          const resTime = await updateNurseTimeOff(authToken, Number(id), {
            status: approveStatus,
            comments: '',
            approved_manager: facility?.id?.toString()
          });

          socket?.emit('tableTimeOffInsert', {
            table: 'NurseTimeOff',
            nurseTableID: Number(nurseData?.id)
          });
          sendNotification(authToken, {
            expoPushToken: nurseData?.mobileId,
            title: `Time Off Request(${moment(resTime?.startDate).format(
              'MMM DD'
            )})`,
            body: `Time off Request Approved.`,
            data: { screen: 'TimeOffScreen' }
          });
          await postNurseNotification(
            authToken,
            Number(nurseData?.id),
            '',
            `Time Off Request(${moment(resTime?.startDate).format('MMM DD')})`,
            `Time off Request Approved.`,
            'TimeOffScreen',
            {
              id: ''
            },
            false,
            false,
            'green',
            ''
          ).catch(e => console.log('error', e, nurseData?.id));
          socket?.emit('tableNotificationInsert', {
            table: 'NurseNotificationTable',
            id: nurseData?.id
          });

          toast.success('Time Off request approved successfully.', {
            theme: 'colored'
          });
          setRefresh(!refresh);
        } catch (error) {
          console.log('data save error:', error);
        }
      } else {
        toast.danger(`Date Conflict.Choose a different date.`, {
          theme: 'colored'
        });
      }
    } else {
      try {
        const resTime = await updateNurseTimeOff(authToken, Number(id), {
          status: approveStatus,
          comments: '',
          approved_manager: facility?.id?.toString(),
          nurseCancelNotes: nurseCancelNotes
        });
        socket?.emit('tableTimeOffInsert', {
          table: 'NurseTimeOff',
          nurseTableID: nurseData?.id
        });
        sendNotification(authToken, {
          expoPushToken: nurseData?.mobileId,
          title: `Time Off Request(${moment(resTime?.startDate).format(
            'MMM DD'
          )})`,
          body: `Time off Request Not Approved.`,
          data: { screen: 'TimeOffScreen' }
        });
        await postNurseNotification(
          authToken,
          Number(nurseData?.id),
          '',
          `Time Off Request(${moment(resTime?.startDate).format('MMM DD')})`,
          `Time off Request Not Approved`,
          'TimeOffScreen',
          {
            id: ''
          },
          false,
          false,
          'red',
          ''
        );
        socket?.emit('tableNotificationInsert', {
          table: 'NurseNotificationTable',
          id: nurseData?.id
        });
        toast.success('Time Off request not-approved successfully.', {
          theme: 'colored'
        });
        setRefresh(!refresh);
      } catch (error) {
        console.log('data save error:', error);
      }
    }
  };

  return (
    <tr className={classNames({ 'border-0': isLast })}>
      <td
        className={classNames('align-middle ps-0 text-nowrap', {
          'border-0': isLast
        })}
      >
        <Flex alignItems="center" className="position-relative">
          {/* <Image src={img} alt={title} className="me-2" width={30} /> */}
          <div className="flex-1">
            <h6 className="mb-0">Reason : {timeOffReason}</h6>
            {comments && <p className="mb-0">Comments : {comments}</p>}
            {nurseCancelNotes && (
              <p className="mb-0">Cancellation Notes : {nurseCancelNotes}</p>
            )}
          </div>
        </Flex>
      </td>
      <td className={classNames('align-middle px-4', { 'border-0': isLast })}>
        {startDate === endDate ? (
          <h6 className="mb-0">{moment(startDate).format('MMM-DD')}</h6>
        ) : (
          <h6 className="mb-0">
            {moment(startDate).format('MMM-DD')} -{' '}
            {moment(endDate).format('MMM-DD')}
          </h6>
        )}
      </td>
      <td className={classNames('align-middle px-4', { 'border-0': isLast })}>
        {startTime === '' && endTime === '' ? (
          <h6 className="mb-0">Full Day</h6>
        ) : (
          <h6 className="mb-0">
            {moment(new Date(startTime)).format('h:mma')}-
            {moment(new Date(endTime)).format('h:mma')}
            {timeDifferentCard(startTime, endTime)}
          </h6>
        )}
      </td>
      <td
        className={classNames('align-middle px-4', { 'border-0': isLast })}
        style={{ width: '1%' }}
      >
        <SubtleBadge
          bg={classNames({
            success: status === 'Approved',
            secondary: status === 'Pending',
            warning: status === 'Cancelled',
            danger: status === 'Not-Approved'
          })}
          className="fs-10 w-100"
        >
          {status}
        </SubtleBadge>
      </td>
      <td
        className={classNames('align-middle px-4 text-end text-nowrap', {
          'border-0': isLast
        })}
        style={{ width: '1%' }}
      >
        <Flex alignItems="center" className="position-relative">
          {nurseData?.profileImage ? (
            <Image
              roundedCircle
              src={nurseData?.profileImage}
              alt={nurseData?.firstName + ' ' + nurseData?.lastName}
              className="me-2"
              width={40}
              height={40}
            />
          ) : (
            <Avatar
              size="2xl"
              name={nurseData?.firstName + ' ' + nurseData?.lastName}
              className="me-2"
            />
          )}
          <div className="flex-1">
            <h6 className="mb-0">
              {nurseData?.firstName + ' ' + nurseData?.lastName}
            </h6>
          </div>
        </Flex>
      </td>
      <td
        className={classNames('align-middle px-4 text-end text-nowrap', {
          'border-0': isLast
        })}
        style={{ width: '1%' }}
      >
        <Flex alignItems="center" className="position-relative">
          {status !== 'Pending' &&
            (approvedManagerData?.profileImage ? (
              <Image
                roundedCircle
                src={approvedManagerData?.profileImage}
                alt={
                  approvedManagerData?.firstName +
                  ' ' +
                  approvedManagerData?.lastName
                }
                className="me-2"
                width={40}
                height={40}
              />
            ) : (
              <Avatar
                size="2xl"
                name={
                  approvedManagerData?.firstName +
                  ' ' +
                  approvedManagerData?.lastName
                }
                className="me-2"
              />
            ))}
          <div className="flex-1">
            {status === 'Pending' ? (
              // <h6 className="mb-0">Waiting</h6>
              <div className="flex-1">
                {status === 'Pending' ? (
                  // <h6 className="mb-0">Waiting</h6>
                  <Flex>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => actionTimeOff('Approved')}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      className="mx-3"
                      onClick={() => actionTimeOff('Not-Approved')}
                    >
                      Reject
                    </Button>
                  </Flex>
                ) : (
                  <>
                    <h6 className="mb-0">{status} By</h6>
                    <p className="fs-11 mb-0">
                      {approvedManagerData?.firstName +
                        ' ' +
                        approvedManagerData?.lastName}
                    </p>
                  </>
                )}
              </div>
            ) : (
              <>
                <h6 className="mb-0">{status} By</h6>
                <p className="fs-11 mb-0">
                  {approvedManagerData?.firstName +
                    ' ' +
                    approvedManagerData?.lastName}
                </p>
              </>
            )}
          </div>
        </Flex>
      </td>
      {/* <td
        className={classNames('align-middle ps-4 pe-1', { 'border-0': isLast })}
        style={{ width: '130px', minWidth: '130px' }}
      >
        <Form.Select size="sm" className="px-2">
          <option value="action">Action</option>
          <option value="Approved">Approved</option>
          <option value="Not-Approved">Not-Approved</option>
          <option value="Cancelled">Cancelled</option>
        </Form.Select>
      </td> */}
    </tr>
  );
};

const TimeOffViewList = ({
  data: transactions,
  refresh,
  setRefresh,
  facility
}) => {
  return (
    <>
      <Card className="overflow-hidden">
        {/* <Card.Header className="pe-0">
          <Flex className="g-2">
            <Col>
              <h5 className="mb-0">Time Off List ({transactions?.length})</h5>
            </Col>
          </Flex>
        </Card.Header> */}
        <Card.Body className="py-0">
          {transactions?.length === 0 ? (
            <div className="my-3">
              <p>No Data Available</p>
            </div>
          ) : (
            <SimpleBarReact>
              <Table className="table-dashboard mb-0 fs-10">
                <tbody>
                  {transactions?.map((item, index) => (
                    <TransactionItem
                      key={item.id}
                      index={index}
                      isLast={index === transactions?.length - 1}
                      summary={item}
                      facility={facility}
                      refresh={refresh}
                      setRefresh={setRefresh}
                    />
                  ))}
                </tbody>
              </Table>
            </SimpleBarReact>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

TransactionItem.propTypes = {
  summary: PropTypes.shape({
    approvedManagerData: PropTypes.any,
    nurseCancelNotes: PropTypes.any,
    timeOffReason: PropTypes.any,
    startDate: PropTypes.any,
    startTime: PropTypes.any,
    endDate: PropTypes.any,
    endTime: PropTypes.any,
    alternateContactNumber: PropTypes.any,
    phoneNumber: PropTypes.any,
    comments: PropTypes.any,
    status: PropTypes.any,
    organization: PropTypes.any,
    location_id: PropTypes.any,
    nurseTableID: PropTypes.any,
    nurseData: PropTypes.any,
    id: PropTypes.number.isRequired
  }),
  isLast: PropTypes.bool.isRequired,
  facility: PropTypes.any,
  refresh: PropTypes.any,
  setRefresh: PropTypes.any
};

TimeOffViewList.propTypes = {
  data: PropTypes.arrayOf(TransactionItem.propTypes.summary),
  refresh: PropTypes.any,
  setRefresh: PropTypes.any,
  facility: PropTypes.any
};

export default TimeOffViewList;
